import React from 'react';
import PostalCodeInputWUT from '../../../ui/address-input/postal-code-input-wut';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useAddressAutofill } from '../../multiline-address/multiline-address/address-autofill-context';
import JapanPostalCodeMarkWUT from './japan-postal-code-mark-wut';
const JapanPostalCodeWUT = ({ autocomplete, ...props })=>{
    const prefix = /*#__PURE__*/ React.createElement(JapanPostalCodeMarkWUT, null);
    const { autocompleteEnabled } = useAddressAutofill();
    return autocomplete || autocompleteEnabled ? /*#__PURE__*/ React.createElement(PostalCodeInputWUT, {
        ...props,
        prefix: prefix
    }) : /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        prefix: prefix
    });
};
export default JapanPostalCodeWUT;

//# sourceMappingURL=japan-postal-code-wut.js.map